export enum REFERRAL_STATUS {
    AVAILABLE = 'Available',
    PROVIDER_REQUEST = 'Provider_Request',
    MATCHED = 'Matched',
    COMPLETE = 'Complete',
}

export enum PAGE {
    OPEN_REFERRALS = 'Open Referrals',
    MATCHED_REFERRALS = 'Matched Providers',
    PROVIDER_REQUEST = 'Provider Requests',
    COMPLETE_REFERRALS = 'Complete Referrals'
}

export enum ServiceLocationType {
    Home = "Home",
    ClinicCenter = "ClinicCenter",
    Community = "Community",
    Telehealth = "Telehealth",
    SchoolDayCare = "SchoolDayCare",
    TelehealthAssessmentOnly = "TelehealthAssessmentOnly",
}

export enum ReferralConsideration {
    ClinicBased = 'Clinic based',
    Escalation = 'Escalation',
    ProviderRequest = 'Provider Request',
    Siblings = 'Siblings',
    TranslationServices = 'Translation Services',
    CPITraining = 'CPI Training',
    OutOfServiceArea = 'Out of Service Area'
}

export enum PlacementType {
    AssessmentWithConcurrentTreatment = 'Assessment with Concurrent Treatment',
    AssessmentOnly = 'Assessment Only',
    TreatmentOnly = 'Treatment Only',
    TransferReevaluation = 'Transfer Reevaluation'
}

export enum ServiceType {
    ABAParentTraining = 'ABA Parent Training',
    ABAServicesSevereBehavior = 'ABA Services - Severe Behavior',
    Coaching = 'Coaching',
    GroupABA = 'Group ABA',
    ParentLedABA = 'Parent Led ABA',
    PLAYProject = 'PLAY Project',
    SocialSkillsGroup = 'Social Skills Group',
    TraditionalABA = '3-Tier ABA',
    ThreeTierOrParentTraining = '3-Tier ABA OR ABA Parent Training',
    ThreeTierORParentLed = '3-Tier ABA OR Parent Led ABA',
    Chat = 'Chat',
    Connect = 'Connect',
    Calibrate = "Calibrate ABA",
    Compass_Behavioral = "Compass-Behavioral",
    RUBI = "RUBI",
    Compass_Psychotherapy = "Compass Psychotherapy",
    Psychotherapy = "Psychotherapy",
}


const portalEnumMapper = [
    {value: 'Assessment with Concurrent Treatment', name: 'Assessment_with_Concurrent_Treatment'},
    {value: 'Transfer Reevaluation', name: 'Transfer_Reevaluation'},
    {value: 'Assessment Only', name: 'Assessment_Only'},
    {value: 'Treatment Only', name: 'Treatment_Only'},
    {value: 'Clinic based', name: 'Clinic_based'},
    {value: 'Escalation', name: 'Escalation'},
    {value: 'Provider Request', name: 'Provider_Request'},
    {value: 'Siblings', name: 'Siblings'},
    {value: 'Translation Services', name: 'Translation_Services'},
    {value: 'CPI Training', name: 'CPI_Training'},
    {value: 'Out of Service Area', name: 'Out_of_Service_Area'},
    {value: 'ABA Parent Training', name: 'ABA_Parent_Training'},
    {value: 'ABA Services - Severe Behavior', name: 'ABA_Services_Severe_Behavior'},
    {value: 'Coaching', name: 'Coaching'},
    {value: 'Group ABA', name: 'Group_ABA'},
    {value: 'Parent Led ABA', name: 'Parent_Led_ABA'},
    {value: 'PLAY Project', name: 'PLAY_Project'},
    {value: 'Social Skills Group', name: 'Social_Skills_Group'},
    {value: '3-Tier ABA', name: 'Traditional_ABA'},
    {value: '3-Tier ABA OR ABA Parent Training', name: 'Three_Tier_OR_Parent_Training'},
    {value: '3-Tier ABA OR Parent Led ABA', name: 'Three_Tier_OR_Parent_Led'},
    {value: 'Chat', name: 'Chat'},
    {value: 'Connect', name: 'Connect'},
    {value: 'Calibrate ABA', name: 'Calibrate'},
    {value: 'Compass-Behavioral', name: 'Compass_Behavioral'},
    {value: 'RUBI', name: 'RUBI'},
    {value: 'Compass Psychotherapy', name: 'Compass_Psychotherapy'},
    {value: 'Psychotherapy', name: 'Psychotherapy'},
]

export const PortalEnumValueToName = new Map(
    portalEnumMapper.map(x => [x.value, x.name] as [string, string])
)

export const PortalEnumNameToValue = new Map(
    portalEnumMapper.map(x => [x.name, x.value] as [string, string])
)

const serviceLocationMapper = [
    {value: 'Home', name: ServiceLocationType.Home},
    {value: 'Clinic/Center', name: ServiceLocationType.ClinicCenter},
    {value: 'Community', name: ServiceLocationType.Community},
    {value: 'School/Day care', name: ServiceLocationType.SchoolDayCare},
    {value: 'Telehealth', name: ServiceLocationType.Telehealth},
    {value: 'Telehealth - Assessment Only, Treatment in Person', name: ServiceLocationType.TelehealthAssessmentOnly},
]

export const ServiceLocationEnumNameToValue = new Map(
    serviceLocationMapper.map(x => [x.name, x.value] as [string, string])
)

const treatmentConsiderationMapper = [
    {value: 'Services must be provided in a clinic setting', name: ReferralConsideration.ClinicBased},
    {
        value: 'Client has a sibling that is also receiving services; family prefers to place with the same provider.',
        name: ReferralConsideration.Siblings
    },
    {value: 'Translation services can be used in-session', name: ReferralConsideration.TranslationServices}
]

export const TreatmentConsiderEnumNameToValue = new Map(
    treatmentConsiderationMapper.map(x => [x.name, x.value] as [string, string])
)

export enum SpecialReferralConsideration {
    Siblings = 'Siblings',
    ClinicBased = 'Clinic based',
    OutOfServiceArea = 'Out of Service Area',
    ProviderPreference = 'Provider Preference'
}

export const DEFAULT_SORT_COLUMN = 'daysInPlacement';
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGE = PAGE.OPEN_REFERRALS;

export const ReturnedDeclinedPartyOptions = [{
    value: '',
    label: 'Declined Party'
}, ...['Provider', 'Client', 'Catalight Care Services'].map((item) => {
    return {value: item, label: item};
})]

// BHPNPP-1341, BHPNPP-2026 if any update here, please update backend too, to avoid error on saving to Salesforce
const reason = [
    "Administrative Error",
    "CCS administrative request",
    "Client/Family Moved",
    "Client/Family declining treatment offers",
    "Client/Family preference",
    "Client/Family schedule changed",
    "Concerns with client engagement",
    "Disagrees with treatment recommendations",
    "Dual Relationship",
    "Prefers clinic closer to home",
    "Prefers in-person treatment",
    "Provider agency operations change",
    "Provider has concerns with family/client",
    "Provider’s inability to staff",
    "Referral unmatched by CCS",
    "Service recovered with previous provider",
    "Service Not offered by Provider",
    "Service quality concerns",
];

export const ReturnedReasonOptions = [{
    value: '',
    label: 'Returned Reason'
}, ...reason.map((item) => {
    return {value: item, label: item}
})];

export const UnmatchedReasonOptions = [{
    value: '',
    label: 'Declined Reason'
}, ...reason.map((item) => {
    return {value: item, label: item}
})];

// BHPNPP-1064
export const SLA_BUSINESS_DAYS = 10;
export const SPLIT_DELIMITER = '; ';

export const splitAndRemoveEmpty = (val: string): string[] => {
    if (val) {
        return val
            .split(SPLIT_DELIMITER)
            .map((val) => val.trim())
            .filter((val) => val !== '');
    }

    return [];
}
